import { render, staticRenderFns } from "./AuctionBuyersPremiumLink.vue?vue&type=template&id=3e4b622c&scoped=true"
import script from "./AuctionBuyersPremiumLink.vue?vue&type=script&lang=js"
export * from "./AuctionBuyersPremiumLink.vue?vue&type=script&lang=js"
import style0 from "./AuctionBuyersPremiumLink.vue?vue&type=style&index=0&id=3e4b622c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4b622c",
  null
  
)

export default component.exports